import React from "react";
import { Icon } from "./Icon";

interface Youtube32Props {
  size?: number;
  className?: string;
  color?: string;
}

export const Youtube32: React.FC<Youtube32Props> = ({
  size,
  className,
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M931.2 348.8c-3.2-54.4-38.4-128-105.6-128-208-16-416-16-624 0-64 6.4-105.6 80-112 137.6-9.6 102.4-9.6 204.8 0 307.2 3.2 57.6 44.8 131.2 108.8 140.8 208 12.8 416 12.8 624 0 60.8-9.6 102.4-83.2 108.8-140.8 9.6-105.6 9.6-211.2 0-316.8zM403.2 665.6v-307.2l268.8 153.6-268.8 153.6z" />
    </Icon>
  );
};
